/*
 * UserControl Messages
 *
 * This contains all the text for the UserControl component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  signIn: {
    id: 'app.components.UserControl.signIn',
    defaultMessage: 'Sign In',
  },
  retrySignIn: {
    id: 'app.components.UserControl.retrySignIn',
    defaultMessage: 'Retry sign-in',
  },
  signOut: {
    id: 'app.components.UserControl.signOut',
    defaultMessage: 'Sign Out',
  },
  account: {
    id: 'app.components.UserControl.account',
    defaultMessage: 'Account',
  },
  support: {
    id: 'app.components.UserControl.support',
    defaultMessage: 'Support RunnerMaps',
  },
  login: {
    id: 'app.containers.KmVretersPage.login',
    defaultMessage: 'You must <a href="#login">sign in</a> first',
  },
});
